/** The served range door's one-minute refresh budget, shared by both readers. */
export const RANGE_CADENCE_MS = 60_000;
